import {createSvgIcon} from '../create-svg-icon';

export const LocalPrintshopIcon = createSvgIcon(
  [<path d="M19 8h-1V3H6v5H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zM8 5h8v3H8V5zm8 14H8v-4h8v4zm2-4v-2H6v2H4v-4c0-.55.45-1 1-1h14c.55 0 1 .45 1 1v4h-2z" key="0" />,<circle cx="18" cy="11.5" r="1" key="1" />,]
, 'LocalPrintshopOutlined');
